// extracted by mini-css-extract-plugin
export default {"link":"skqui","inheritColor":"BcDXm"};